var $name="countryCodes",$path="configs/countryCodes.js",$this={$name,$path,};module.exports = {
  china: 'cn',
  default: 'ww',
  france: 'fr',
  russia: 'ru',
  unitedStates: 'us',
};
